<template>
	<div v-if="resources.length" class="resource-dashboard">
		<h2>{{ title }}</h2>
		<div class="dashboard-cnt">
			<div
				v-for="resource in resources"
				:key="resource.resource_ID"
				class="dashboard-row"
				@click="onResourceClick(resource)"
			>
				<img
					v-if="isResourceFileWithType(resource, 'image')"
					:src="`data:${resource.fileType};base64, ${resource.fileDataBase64}`"
					:alt="resource.name"
				/>
				<div class="text-wrapper">
					<h4>{{ resource.name }}</h4>
					<div class="body-text-1">{{ resource.description }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		resources: {
			type: Array,
			default: null
		},
		title: {
			type: String,
			default: ''
		}
	},
	methods: {
		onResourceClick(resource) {
			if (resource.link) {
				window.open(resource.link, '_blank');
			} else if (this.isResourceFileWithType(resource, 'image')) {
				this.$emit('imageSelected', resource);
			} else if (this.isResourceFileWithType(resource, 'application')) {
				this.$emit('fileRequested', resource);
			}
		},
		isResourceFileWithType(resource, mimetype) {
			return resource.fileType && resource.fileType.includes(mimetype);
		}
	}
};
</script>
<style lang="scss" scoped>
.resource-dashboard {
	width: 100%;

	h2 {
		margin-top: 32px;
		margin-bottom: 8px;
	}

	.dashboard-cnt {
		box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
		background-color: $container-bgcolor;
		border: 1px solid $container-border;

		.dashboard-row {
			display: flex;
			align-items: center;
			padding: 32px;

			&:not(:last-child) {
				border-bottom: 1px solid $container-border;
			}

			img {
				height: 88px;
				margin-right: 16px;
			}

			.text-wrapper {
				width: 100%;
				h4 {
					margin-top: 0;
					margin-bottom: 4px;
				}

				.body-text-1 {
					width: 100%;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}

			&:hover {
				cursor: pointer;
			}
		}
	}

	&:last-child {
		padding-bottom: 84px;
	}
}
</style>
